import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/close.png'


const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "info-box" }
const _hoisted_3 = { class: "align-items info-i" }
const _hoisted_4 = { class: "input-box" }
const _hoisted_5 = {
  key: 0,
  class: "tips"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "align-items info-i" }
const _hoisted_8 = {
  key: 0,
  class: "name"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "head-i align-items color-grey font-base" }
const _hoisted_11 = { class: "align-items info-i" }
const _hoisted_12 = { class: "input-box" }
const _hoisted_13 = { class: "flex flex-jc-sb" }
const _hoisted_14 = { class: "flex info-i-1" }
const _hoisted_15 = { class: "mg-l-10" }
const _hoisted_16 = { class: "flex info-i-1" }
const _hoisted_17 = { class: "mg-l-10" }
const _hoisted_18 = { class: "flex info-i-1" }
const _hoisted_19 = { class: "mg-l-10" }
const _hoisted_20 = { class: "btn-box align-items justify-center mg-t-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isCloseType ? '' : _ctx.close()))
  }, [
    _createElementVNode("div", {
      class: "container-c",
      style: _normalizeStyle({ width: _ctx.width }),
      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.dataTitle), 1),
      _createElementVNode("div", {
        class: "close point",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, "×"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "name" }, [
            _createElementVNode("span", { class: "color-red font-small" }, "* "),
            _createElementVNode("span", { class: "color-black font-small" }, "企业名")
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              disabled: _ctx.echo,
              modelValue: _ctx.enterpriseName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.enterpriseName) = $event)),
              onInput: _ctx.onEnterpriseName,
              placeholder: "请输入员工实际上班企业"
            }, null, 8, ["disabled", "modelValue", "onInput"]),
            (_ctx.enterpriseList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enterpriseList, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "tip-i point",
                      key: index,
                      onClick: ($event: any) => (_ctx.onSelect(item))
                    }, _toDisplayString(item.name), 9, _hoisted_6))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "name" }, [
            _createElementVNode("span", { class: "color-red font-small" }, "* "),
            _createElementVNode("span", { class: "color-black font-small" }, "负责人")
          ], -1)),
          _createElementVNode("div", {
            class: "input-box",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSelectHead && _ctx.onSelectHead(...args)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.dataHeadList.length > 0 ? 'head-list-active' : '', 'head-list'])
            }, [
              (_ctx.dataHeadList.length == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "请选择"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataHeadList, (item, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (index <= _ctx.isHeadWhole)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "align-items",
                        onClick: _withModifiers(($event: any) => (_ctx.onDeleteHead(item.id)), ["stop"])
                      }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", null, _toDisplayString(item.userName), 1),
                          _cache[12] || (_cache[12] = _createElementVNode("img", {
                            src: _imports_0,
                            class: "close-img",
                            alt: ""
                          }, null, -1))
                        ])
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128)),
              (_ctx.dataHeadList.length > _ctx.isHeadWhole + 1)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "head-i color-grey font-base",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onHeadWhole && _ctx.onHeadWhole(...args)), ["stop"]))
                  }, " +" + _toDisplayString(_ctx.dataHeadList.length - 3), 1))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "name" }, [
            _createElementVNode("span", { class: "color-red font-small" }, "* "),
            _createElementVNode("span", { class: "color-black font-small" }, "手机号")
          ], -1)),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.phone) = $event)),
              placeholder: "选择负责人后自动填入",
              disabled: true
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "" }, [
              _createElementVNode("span", { class: "color-red font-small" }),
              _createElementVNode("span", { class: "color-black font-small" }, "预支工资")
            ], -1)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.isAdvance,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isAdvance) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "" }, [
              _createElementVNode("span", { class: "color-red font-small" }),
              _createElementVNode("span", { class: "color-black font-small" }, "领薪收集员工身份证")
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.switchCard,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.switchCard) = $event))
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "" }, [
              _createElementVNode("span", { class: "color-red font-small" }),
              _createElementVNode("span", { class: "color-black font-small" }, "负责人电话")
            ], -1)),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.isPhone,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isPhone) = $event))
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_button, {
            class: "mini-btn btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close()))
          }, {
            default: _withCtx(() => _cache[18] || (_cache[18] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "mini-btn btn",
            type: "primary",
            onClick: _ctx.onAddDetermine
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("确定")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ], 4)
  ]))
}